import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { StyledButton } from "./StyledButton";
import { loginRequest } from "../authConfig";

type SignInOutButtonProps = {
  isSignIn: boolean;
};

export const SignInOutButton = ({ isSignIn }: SignInOutButtonProps) => {
  const { t } = useTranslation("common");
  const { instance } = useMsal();
  const history = useHistory();

  const handleLogin = () => {
    instance.loginPopup(loginRequest)
      .then(() => {
        history.push("/datasets");
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    }).catch((e: Error) => {
      console.error(e);
    });
  };

  return (
    <StyledButton onClick={() => (isSignIn ? handleLogin() : handleLogout())}>
      {isSignIn ? t("Sign in") : t("Sign Out")}
    </StyledButton>
  );
};
